import { CategoryData } from '../types/CategoryData';

function toId(x: number | string | { value: number | string }): number {
  return typeof x === 'object' && x !== null && 'value' in x
    ? Number(x.value)
    : Number(x);
}

export const extractId = (v: any) =>
  typeof v === 'object' && v !== null && 'value' in v ? v.value : v;

export function findSelectedCategory(
  categories: CategoryData[],
  categoryOrId: any
) {
  const id = toId(categoryOrId);
  return categories.find((c) => c.id === id) || undefined;
}

export function getSubcategories(cat?: CategoryData, all = false) {
  return (
    cat?.subcategories?.filter((category) =>
      all ? true : !!category.product_count
    ) || []
  );
}

export function findSelectedSubcategory(subs: CategoryData[], subOrId: any) {
  const id = toId(subOrId);
  return subs.find((s) => s.id === id) || undefined;
}

export const getSubSubCategories = getSubcategories;
